import styled from 'styled-components';

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  color: gray;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const css = {
  List,
};

export default css;
